import i18n from "i18next"
import Backend from "i18next-http-backend"
import { initReactI18next } from "react-i18next"
// Uzbek Cyrillic
import authKR from "@/shared/locales/kr/auth.json"
import commonKR from "@/shared/locales/kr/common.json"
import energyAuditKR from "@/shared/locales/kr/energy-audit.json"
import errorsKR from "@/shared/locales/kr/errors.json"
import notificationKR from "@/shared/locales/kr/notification.json"
import sidebarKR from "@/shared/locales/kr/sidebar.json"
import tableKR from "@/shared/locales/kr/table.json"
// Russian
import authRU from "@/shared/locales/ru/auth.json"
import commonRU from "@/shared/locales/ru/common.json"
import energyAuditRU from "@/shared/locales/ru/energy-audit.json"
import errorsRU from "@/shared/locales/ru/errors.json"
import notificationRU from "@/shared/locales/ru/notification.json"
import sidebarRU from "@/shared/locales/ru/sidebar.json"
import tableRU from "@/shared/locales/ru/table.json"
// Uzbek Latin
import authUz from "@/shared/locales/uz/auth.json"
import commonUZ from "@/shared/locales/uz/common.json"
import energyAuditUZ from "@/shared/locales/uz/energy-audit.json"
import errorsUZ from "@/shared/locales/uz/errors.json"
import notificationUZ from "@/shared/locales/uz/notification.json"
import sidebarUZ from "@/shared/locales/uz/sidebar.json"
import tableUZ from "@/shared/locales/uz/table.json"
import type {
  ILocaleLeafKeysCommon,
  ILocaleLeafKeysEnergyAudit,
  ILocaleLeafKeysErrors,
  ILocaleLeafKeysNotification,
  ILocaleLeafKeysSidebar,
  ILocaleLeafKeysTable,
  IResourceKeyUnion
} from "@/shared/types/i18n-resource-keys.ts"
import { defaultLocale } from "../locales"

const initializeI18n = async () => {
  try {
    i18n
      .use(Backend)
      .use(initReactI18next)
      .init({
        lng: localStorage.getItem("i18nextLng") || defaultLocale,
        fallbackLng: defaultLocale,
        // debug: true,
        ns: ["energyAudit", "sidebar", "auth", "common", "table", "errors", "notification"],
        defaultNS: "common",
        resources: {
          ru: {
            energyAudit: energyAuditRU,
            sidebar: sidebarRU,
            common: commonRU,
            errors: errorsRU,
            table: tableRU,
            auth: authRU,
            notification: notificationRU
          },
          uz: {
            energyAudit: energyAuditUZ,
            sidebar: sidebarUZ,
            common: commonUZ,
            errors: errorsUZ,
            table: tableUZ,
            auth: authUz,
            notification: notificationUZ
          },
          uzKr: {
            energyAudit: energyAuditKR,
            sidebar: sidebarKR,
            common: commonKR,
            errors: errorsKR,
            table: tableKR,
            auth: authKR,
            notification: notificationKR
          }
        }
      })
  } catch (error) {
    console.error("Error initializing i18n:", error)
  }
}
initializeI18n()

export const IBaseI18nResources = {
  energyAudit: energyAuditRU,
  sidebar: sidebarRU,
  common: commonRU,
  errors: errorsRU,
  table: tableRU,
  auth: authRU,
  notification: notificationRU
} as const

const gt = (key: IResourceKeyUnion, fallback?: string | null | number) => {
  return i18n.exists(key) ? i18n.t(key) : (fallback ?? key)
}

export const tCommon = (key: ILocaleLeafKeysCommon, fallback?: string | null | number) => {
  return gt(`common:${key}` as IResourceKeyUnion, fallback).toString()
}

export const tSidebar = (key: ILocaleLeafKeysSidebar, fallback?: string | null | number) => {
  return gt(`sidebar:${key}` as IResourceKeyUnion, fallback)
}

export const tTable = (key: ILocaleLeafKeysTable, fallback?: string | null | number) => {
  return gt(`table:${key}` as IResourceKeyUnion, fallback)
}

export const tError = (key: ILocaleLeafKeysErrors, fallback?: string | null | number) => {
  return gt(`errors:${key}` as IResourceKeyUnion, fallback)
}

export const tEnergyAudit = (key: ILocaleLeafKeysEnergyAudit, fallback?: string | null | number) => {
  return gt(`energyAudit:${key}` as IResourceKeyUnion, fallback)
}

export const tNotification = (key: ILocaleLeafKeysNotification, fallback?: string | null | number) => {
  return gt(`notification:${key}` as IResourceKeyUnion, fallback)
}
export default i18n

export { gt, initializeI18n }
